import actionConstants from '../constants/ActionConstants';

const initialState = {
  errorMsg: '',
  isFetching: false,
  isSuccess: false,
  recurringInspectionList: [],
  totalCount: null,
  totalPages: null,
  currentPage: null,
};

const fetchRecurringInspections = (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.FETCH_RECURRING_INSPECTION_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case actionConstants.FETCH_RECURRING_INSPECTION_INITIAL_REQUEST:
      return {
        ...state,
        isFetching: true,
        recurringInspectionList: [],
      };
    case actionConstants.FETCH_RECURRING_INSPECTION_SUCCESS:
      return {
        ...state,
        recurringInspectionList: [...state.recurringInspectionList, ...action.payload.docs],
        totalCount: action.payload.total,
        totalPages: action.payload.pages,
        currentPage: action.payload.page,
        isSuccess: true,
        isFetching: false,
      };
    case actionConstants.FETCH_RECURRING_INSPECTION_FAILURE:
      return {
        ...state,
        errorMsg: action.message,
        isFetching: false,
      };
    case actionConstants.CLEAR_STATE:
      return {
        ...state,
        isFetching: false,
        isSuccess: false,
        errorMsg: '',
        totalCount: 0,
      };
    default:
      return state;
  }
};

export default fetchRecurringInspections;
